import React from "react";

const UniInputLabel = ({ title, required = false }) => {
  return (
    <div className="text-[16px] font-bold text-black">
      {title} {required && <span className="text-red-600">*</span>}
    </div>
  );
};

export default UniInputLabel;
